import { render, staticRenderFns } from "./AccountAdministration.vue?vue&type=template&id=648a4c0f&scoped=true"
import script from "./AccountAdministration.vue?vue&type=script&lang=js"
export * from "./AccountAdministration.vue?vue&type=script&lang=js"
import style0 from "./AccountAdministration.vue?vue&type=style&index=0&id=648a4c0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a4c0f",
  null
  
)

export default component.exports